import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GlobalService } from '../../../services/global.service';
import { MessageService } from '../../../services/message.service';
import { GraphService } from '../../../services/graphs.service';
import { Observable } from 'rxjs';
import { ConfigModel, EhsConfigModel, OpsMonthConfigModel, OpsProductionAreaModel, OpsProductionTypeModel, OpsWellsDrilledandConnectedModel, OpsExplorationAndDrillingMilestonesModel } from 'src/app/models/graphs.model';
import { WellsModel } from 'src/app/models/wells.model';
import { PersonalSafetyComponent } from '../ehs/personalSafety/personalSafety.component';
import { ProcessSafetyComponent } from '../ehs/processSafety/processSafety.component';
import { Router } from '@angular/router';
import { OnshoreOffshoreProdVolComponent } from '../ops/onshoreOffshoreProdVol/onshoreOffshoreProdVol.component';
import { OnshoreOffshoreProdTypeComponent } from '../ops/onshoreOffshoreProdType/onshoreOffshoreProdType.component';
import { WellsDrilledandConnectedComponent } from '../ops/wellsdrilledandconnected/wellsdrilledandconnected.component';
// import { AgGridNg2 } from 'ag-grid-angular';
import { ExplorationWellsComponent } from '../ops/explorationWells/explorationWells.Component';
import { SalesRevenueComponent } from '../fin/salesRevenue/salesRevenue.component';
import { UpstreamUnitProductionCostComponent } from '../fin/upstreamUnitProductionCost/upstreamUnitProductionCost.component';
import { FreeCashFlowComponent } from '../fin/freeCashFlow/freeCashFlow.component';
import { GearingComponent } from '../fin/gearing/gearing.component';
import { UserModel } from 'src/app/models/user.model';

@Component({
    selector: 'app-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
})

export class EditComponent implements AfterViewInit {

    graphService: Observable<any>;
    monthService: Observable<any>;
    wellService: Observable<any>;
    saveGraphData: ConfigModel = new ConfigModel();
    graphData: ConfigModel = new ConfigModel();
    wellData: WellsModel[];
    monthData: OpsMonthConfigModel = new OpsMonthConfigModel();
    oldWellData: WellsModel[];
    newWellData: WellsModel[];
    initialRevQuarter: string;
    initialRevYear: string;
    finCostInitialQuarter: string;
    finCostInitialYear: string;
    finFreeCashFlowInitialQuarter: string;
    finFreeCashFlowInitialYear: string;
    finInitialQuarterGearing: string;
    finInitialYearGearing: string;
    salesValue: ConfigModel = new ConfigModel();
    drilledSubHeading: string;
    user: UserModel = new UserModel();
    subHeading1: string[];
    subHeading2: any;
    myDate: Date;

    public listItems: Array<string> = [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
    ];

    @ViewChild(PersonalSafetyComponent) personalSafety: PersonalSafetyComponent;
    @ViewChild(ProcessSafetyComponent) processSafety: ProcessSafetyComponent;

    @ViewChild(OnshoreOffshoreProdVolComponent) productionArea: OnshoreOffshoreProdVolComponent;
    @ViewChild(OnshoreOffshoreProdTypeComponent) productionType: OnshoreOffshoreProdTypeComponent;
    @ViewChild(WellsDrilledandConnectedComponent) wellsDrilledandconnected: WellsDrilledandConnectedComponent;
    @ViewChild(ExplorationWellsComponent) explorationAndDrillingMilestones: ExplorationWellsComponent;

    @ViewChild(SalesRevenueComponent) salesRevenue: SalesRevenueComponent;
    @ViewChild(UpstreamUnitProductionCostComponent) upstreamUnitProductionCost: UpstreamUnitProductionCostComponent;
    @ViewChild(FreeCashFlowComponent) freeCashFlow: FreeCashFlowComponent;
    @ViewChild(GearingComponent) gearing: GearingComponent;

    // @ViewChild('agGrid') agGrid: AgGridNg2;

    constructor(
        public globals: GlobalService,
        private graph: GraphService,
        private messageService: MessageService,
        public router: Router
    ) {
        //this.myDate = new Date();

        globals.hasLoaded = false;
        globals.currentPage = 1;
        this.graphData = new ConfigModel();
        this.graphService = this.graph.getConfig();
        this.wellService = this.graph.getWells();
        this.monthService = this.graph.getOpsMonth();

        this.graphService.subscribe(data => {
            console.log('Fetched Graphs:');
            this.graphData = data.contents;
            setTimeout(() => {
                if (this.graphData.ehs_InjuryDays_LastDate_Offshore && this.graphData.ehs_InjuryDays_LastDate_Offshore != null) {
                    this.graphData.ehs_InjuryDays_LastDate_Offshore = new Date(this.graphData.ehs_InjuryDays_LastDate_Offshore);
                    this.myDate = new Date(this.graphData.ehs_InjuryDays_LastDate_Offshore);
                    }
            },100);
            this.saveGraphData = data.contents;
            console.log(this.graphData);
            this.globals.hasLoaded = true;
        }, err => {
            console.log(err);
            this.globals.hasLoaded = true;
            let msg = "Error fetching graph details";
            if (err.message != undefined)
                msg += ': ' + err.message;
            this.messageService.sendErrorMessage(msg);
        });
        if (this.globals.opsUser) {
            this.wellService.subscribe(data => {
                console.log('Fetched Wells:');
                this.wellData = data.contents;
                console.log("wells", this.wellData);
            }, err => {
                console.log("Error fetching graph details")
                console.log(err);
                this.globals.hasLoaded = true;
                let msg = "Error fetching graph details";
                if (err.message != undefined)
                    msg += ': ' + err.message;
                this.messageService.sendErrorMessage(msg);
            });
        }

        this.monthService.subscribe(data => {
            this.monthData = data.contents;
        });
    }

    ngAfterViewInit(): void {

        setTimeout(() => {

            // this.plotChart();
            this.plotOperationalProductionAreaChart();
            this.plotOperationalProductionTypeChart();
            this.plotOpsWellsDrilledandConnectedGraph();
            this.load();

            this.graphService.subscribe(data => {
                this.salesValue = data.contents;
            });
        })
    }

    displaySubHeading(subHeading) {
        this.drilledSubHeading = subHeading;
    }

    displayQuarter(quarter) {
        this.initialRevQuarter = quarter;
    }

    displayYear(year) {
        this.initialRevYear = year;
    }

    displayrevenueName1(name1) {

        this.graphData.fin_Revenue_Name1 = name1;
    }
    displayrevenueName2(name2) {

        this.graphData.fin_Revenue_Name2 = name2;
    }
    displayrevenueName3(name3) {

        this.graphData.fin_Revenue_Name3 = name3;
    }
    displayrevenueName4(name4) {

        this.graphData.fin_Revenue_Name4 = name4;
    }

    costDisplayQuarter(quarter) {
        this.finCostInitialQuarter = quarter;
    }

    costDisplayYear(year) {
        this.finCostInitialYear = year;
    }

    displayUnitProdCostName1(name1) {

        this.graphData.fin_Cost_Name1 = name1;
    }
    displayUnitProdCostName2(name2) {

        this.graphData.fin_Cost_Name2 = name2;
    }
    displayUnitProdCostName3(name3) {

        this.graphData.fin_Cost_Name3 = name3;
    }
    displayUnitProdCostName4(name4) {

        this.graphData.fin_Cost_Name4 = name4;
    }

    freeCashFlowDisplayQuarter(quarter) {
        this.finFreeCashFlowInitialQuarter = quarter;
    }

    freeCashFlowDisplayYear(year) {
        this.finFreeCashFlowInitialYear = year;
    }

    displayFreeCashFlowName1(name1) {

        this.graphData.fin_Cash_Name1 = name1;
    }
    displayFreeCashFlowName2(name2) {

        this.graphData.fin_Cash_Name2 = name2;
    }
    displayFreeCashFlowName3(name3) {

        this.graphData.fin_Cash_Name3 = name3;
    }
    displayFreeCashFlowName4(name4) {

        this.graphData.fin_Cash_Name4 = name4;
    }

    gearingDisplayQuarter(quarter) {
        this.finInitialQuarterGearing = quarter;
    }

    gearingisplayYear(year) {
        this.finInitialYearGearing = year;
    }

    displayGearingName1(name1) {

        this.graphData.fin_Gearing_Name1 = name1;
    }
    displayGearingName2(name2) {

        this.graphData.fin_Gearing_Name2 = name2;
    }
    displayGearingName3(name3) {

        this.graphData.fin_Gearing_Name3 = name3;
    }
    displayGearingName4(name4) {

        this.graphData.fin_Gearing_Name4 = name4;
    }

    displayrevenue1(rev1) {
        this.graphData.fin_Revenue_1 = rev1;

    }
    displayrevenue2(rev2) {
        this.graphData.fin_Revenue_2 = rev2;

    }
    displayrevenue3(rev3) {
        this.graphData.fin_Revenue_3 = rev3;

    }
    displayrevenue4(rev4) {
        this.graphData.fin_Revenue_4 = rev4;

    }

    load() {

        this.graphService = this.graph.getConfig();
        this.graphService.subscribe(data => {
            this.graphData = data.contents;

            if ((this.graphData.ops_Drilled_SubHeading) && (this.graphData.ops_Drilled_SubHeading.includes("<br>"))) {
                this.subHeading1 = this.graphData.ops_Drilled_SubHeading.split("<br>");
                this.subHeading2 = this.subHeading1[0] + "\n" + this.subHeading1[1];
                this.graphData.ops_Drilled_SubHeading = this.subHeading2;
            }
        });

        this.wellService = this.graph.getWells();
        this.wellService.subscribe(data => {
            this.oldWellData = data.contents;
        });
    }

    plotChart() {
        if (this.globals.hseUser) {
            this.personalSafety.refresh();
            this.processSafety.refresh();
        }
    }

    plotOperationalProductionAreaChart() {
        if (this.globals.opsUser) {
            this.productionArea.refresh();
        }
    }

    plotOperationalProductionTypeChart() {
        if (this.globals.opsUser) {
            this.productionType.refresh();
        }
    }

    plotOpsWellsDrilledandConnectedGraph() {
        if (this.globals.opsUser) {
            this.wellsDrilledandconnected.refresh();
        }
    }

    saveOpsMonth() {
        this.globals.hasLoaded = false;

        let opsMonthConfigModel: OpsMonthConfigModel = new OpsMonthConfigModel();
        this.graphData.ops_CurrentMonthName = this.monthData.currentMonthName;
        opsMonthConfigModel.currentMonthName = this.graphData.ops_CurrentMonthName;
        opsMonthConfigModel.CurrentYear = this.graphData.ops_CurrentYear;

        let jsonObject: any = JSON.stringify(opsMonthConfigModel);

        this.graphService = this.graph.postOpsMonth(jsonObject);
        this.graphService.subscribe(data => {

            this.globals.hasLoaded = true;
            setTimeout(() => {
                this.messageService.sendSuccessMessage("Saved OPS Month Data Successfully");
            }, 200)
        }, err => {
            console.log(err);
            this.globals.hasLoaded = true;
            let msg = "Error saving OPS Month details";
            if (err.message != undefined)
                msg += ': ' + err.message;
            this.messageService.sendErrorMessage(msg);
        });
    }

    cancelOpsMonth() {
        this.graphData = this.saveGraphData;
    }

    saveOpsProductionArea() {
        this.globals.hasLoaded = false;

        let opsProductionAreaModel: OpsProductionAreaModel = new OpsProductionAreaModel();
        opsProductionAreaModel.ProdArea_OnshoreEA = this.graphData.ops_ProdArea_OnshoreEA;
        opsProductionAreaModel.ProdArea_OffshoreWA = this.graphData.ops_ProdArea_OffshoreWA;
        opsProductionAreaModel.ProdArea_OffshoreNA = this.graphData.ops_ProdArea_OffshoreNA;
        opsProductionAreaModel.ProdArea_PNG = this.graphData.ops_ProdArea_PNG;
        opsProductionAreaModel.ProdArea_Max = this.graphData.ops_ProdArea_Max;

        let jsonObject: any = JSON.stringify(opsProductionAreaModel);

        this.graphService = this.graph.postOpsProductionArea(jsonObject);
        this.graphService.subscribe(data => {

            this.globals.hasLoaded = true;
            setTimeout(() => {
                this.messageService.sendSuccessMessage("Saved OPS Production Area Data Successfully");
            }, 200)
        }, err => {
            console.log(err);
            this.globals.hasLoaded = true;
            let msg = "Error saving OPS Production Area details";
            if (err.message != undefined)
                msg += ': ' + err.message;
            this.messageService.sendErrorMessage(msg);
        });
    }

    cancelOpsProductionArea() {
        this.graphService = this.graph.getConfig();
        this.graphService.subscribe(data => {

            this.graphData = data.contents;
        });

        this.productionArea.load();
    }

    saveOpsProductionType() {
        this.globals.hasLoaded = false;

        let opsProductionTypeModel: OpsProductionTypeModel = new OpsProductionTypeModel();
        opsProductionTypeModel.ProdType_Domgas = this.graphData.ops_ProdType_Domgas;
        opsProductionTypeModel.ProdType_Liquids = this.graphData.ops_ProdType_Liquids;
        opsProductionTypeModel.ProdType_LNG = this.graphData.ops_ProdType_LNG;
        opsProductionTypeModel.ProdType_Max = this.graphData.ops_ProdType_Max;

        let jsonObject: any = JSON.stringify(opsProductionTypeModel);

        this.graphService = this.graph.postOpsProductionType(jsonObject);
        this.graphService.subscribe(data => {

            this.globals.hasLoaded = true;
            setTimeout(() => {
                this.messageService.sendSuccessMessage("Saved OPS Production Type Data Successfully");
            }, 200)
        }, err => {
            console.log(err);
            this.globals.hasLoaded = true;
            let msg = "Error saving OPS Production Type details";
            if (err.message != undefined)
                msg += ': ' + err.message;
            this.messageService.sendErrorMessage(msg);
        });
    }

    cancelOpsProductionType() {
        this.graphService = this.graph.getConfig();
        this.graphService.subscribe(data => {

            this.graphData = data.contents;
        });

        this.productionType.load();
    }

    saveOpsWellsDrilledandConnectedData() {

        this.globals.hasLoaded = false;

        let opsWellsDrilledandConnectedModel: OpsWellsDrilledandConnectedModel = new OpsWellsDrilledandConnectedModel();
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Target = this.graphData.ops_Drilled_Cooper_Target;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_LastYear = this.graphData.ops_Drilled_Cooper_LastYear;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Jan = this.graphData.ops_Drilled_Cooper_Jan;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Feb = this.graphData.ops_Drilled_Cooper_Feb;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Mar = this.graphData.ops_Drilled_Cooper_Mar;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Apr = this.graphData.ops_Drilled_Cooper_Apr;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_May = this.graphData.ops_Drilled_Cooper_May;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Jun = this.graphData.ops_Drilled_Cooper_Jun;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Jul = this.graphData.ops_Drilled_Cooper_Jul;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Aug = this.graphData.ops_Drilled_Cooper_Aug;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Sep = this.graphData.ops_Drilled_Cooper_Sep;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Oct = this.graphData.ops_Drilled_Cooper_Oct;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Nov = this.graphData.ops_Drilled_Cooper_Nov;
        opsWellsDrilledandConnectedModel.Drilled_Cooper_Dec = this.graphData.ops_Drilled_Cooper_Dec;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Target = this.graphData.ops_Drilled_GLNG_Target;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_LastYear = this.graphData.ops_Drilled_GLNG_LastYear;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Jan = this.graphData.ops_Drilled_GLNG_Jan;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Feb = this.graphData.ops_Drilled_GLNG_Feb;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Mar = this.graphData.ops_Drilled_GLNG_Mar;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Apr = this.graphData.ops_Drilled_GLNG_Apr;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_May = this.graphData.ops_Drilled_GLNG_May;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Jun = this.graphData.ops_Drilled_GLNG_Jun;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Jul = this.graphData.ops_Drilled_GLNG_Jul;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Aug = this.graphData.ops_Drilled_GLNG_Aug;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Sep = this.graphData.ops_Drilled_GLNG_Sep;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Oct = this.graphData.ops_Drilled_GLNG_Oct;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Nov = this.graphData.ops_Drilled_GLNG_Nov;
        opsWellsDrilledandConnectedModel.Drilled_GLNG_Dec = this.graphData.ops_Drilled_GLNG_Dec;
        opsWellsDrilledandConnectedModel.Drilled_Max = this.graphData.ops_Drilled_Max;

        if (this.graphData.ops_Drilled_SubHeading) {
            this.graphData.ops_Drilled_SubHeading = this.graphData.ops_Drilled_SubHeading.replace("\n", "<br>");
        }
        opsWellsDrilledandConnectedModel.Drilled_SubHeading = this.graphData.ops_Drilled_SubHeading;

        let jsonObject: any = JSON.stringify(opsWellsDrilledandConnectedModel);

        this.graphService = this.graph.postOpsWellsDrilledandConnected(jsonObject);
        this.graphService.subscribe(data => {

            this.globals.hasLoaded = true;
            setTimeout(() => {
                if ((this.graphData.ops_Drilled_SubHeading) && (this.graphData.ops_Drilled_SubHeading.includes("<br>"))) {
                    this.subHeading1 = this.graphData.ops_Drilled_SubHeading.split("<br>");
                    this.subHeading2 = this.subHeading1[0] + "\n" + this.subHeading1[1];
                    this.graphData.ops_Drilled_SubHeading = this.subHeading2;
                }
                this.messageService.sendSuccessMessage("Saved OPS Wells Drilled and Comnnected Data Successfully");
            })
        }, err => {
            console.log(err);
            this.globals.hasLoaded = true;
            let msg = "Error saving OPS Wells Drilled and Comnnected  details";
            if (err.message != undefined)
                msg += ': ' + err.message;
            this.messageService.sendErrorMessage(msg);
        });

    }

    cancelOpsWellsDrilledandConnectedData() {
        this.graphService = this.graph.getConfig();
        this.graphService.subscribe(data => {

            this.graphData = data.contents;
        });

        this.wellsDrilledandconnected.load();
    }

    saveOpsExplorationAndDrillingMilestonesData() {

        this.explorationAndDrillingMilestones.saveOpsExplorationAndDrillingMilestonesData();
    }

    cancelOpsExplorationAndDrillingMilestonesData() {

        this.explorationAndDrillingMilestones.load();
    }

    inputQuarter(initialRevQuarter) {

        this.salesRevenue.changeQuarter(initialRevQuarter);
        this.switchQuarterYearValueSalesRevenue();
    }

    inputYear(initialRevYear) {

        this.salesRevenue.changeYear(initialRevYear);
        this.switchQuarterYearValueSalesRevenue();
    }

    switchQuarterYearValueSalesRevenue() {

        if (this.salesValue.fin_Revenue_Name1 == this.graphData.fin_Revenue_Name1) {
            this.graphData.fin_Revenue_1 = this.salesValue.fin_Revenue_1;
        } else if (this.salesValue.fin_Revenue_Name2 == this.graphData.fin_Revenue_Name1) {
            this.graphData.fin_Revenue_1 = this.salesValue.fin_Revenue_2;
        } else if (this.salesValue.fin_Revenue_Name3 == this.graphData.fin_Revenue_Name1) {
            this.graphData.fin_Revenue_1 = this.salesValue.fin_Revenue_3;
        } else if (this.salesValue.fin_Revenue_Name4 == this.graphData.fin_Revenue_Name1) {
            this.graphData.fin_Revenue_1 = this.salesValue.fin_Revenue_4;
        } else {
            this.graphData.fin_Revenue_1 = 0;
        }

        if (this.salesValue.fin_Revenue_Name1 == this.graphData.fin_Revenue_Name2) {
            this.graphData.fin_Revenue_2 = this.salesValue.fin_Revenue_1;
        } else if (this.salesValue.fin_Revenue_Name2 == this.graphData.fin_Revenue_Name2) {
            this.graphData.fin_Revenue_2 = this.salesValue.fin_Revenue_2;
        } else if (this.salesValue.fin_Revenue_Name3 == this.graphData.fin_Revenue_Name2) {
            this.graphData.fin_Revenue_2 = this.salesValue.fin_Revenue_3;
        } else if (this.salesValue.fin_Revenue_Name4 == this.graphData.fin_Revenue_Name2) {
            this.graphData.fin_Revenue_2 = this.salesValue.fin_Revenue_4;
        } else {
            this.graphData.fin_Revenue_2 = 0;
        }

        if (this.salesValue.fin_Revenue_Name1 == this.graphData.fin_Revenue_Name3) {
            this.graphData.fin_Revenue_3 = this.salesValue.fin_Revenue_1;
        } else if (this.salesValue.fin_Revenue_Name2 == this.graphData.fin_Revenue_Name3) {
            this.graphData.fin_Revenue_3 = this.salesValue.fin_Revenue_2;
        } else if (this.salesValue.fin_Revenue_Name3 == this.graphData.fin_Revenue_Name3) {
            this.graphData.fin_Revenue_3 = this.salesValue.fin_Revenue_3;
        } else if (this.salesValue.fin_Revenue_Name4 == this.graphData.fin_Revenue_Name3) {
            this.graphData.fin_Revenue_3 = this.salesValue.fin_Revenue_4;
        } else {
            this.graphData.fin_Revenue_3 = 0;
        }

        if (this.salesValue.fin_Revenue_Name1 == this.graphData.fin_Revenue_Name4) {
            this.graphData.fin_Revenue_4 = this.salesValue.fin_Revenue_1;
        } else if (this.salesValue.fin_Revenue_Name2 == this.graphData.fin_Revenue_Name4) {
            this.graphData.fin_Revenue_4 = this.salesValue.fin_Revenue_2;
        } else if (this.salesValue.fin_Revenue_Name3 == this.graphData.fin_Revenue_Name4) {
            this.graphData.fin_Revenue_4 = this.salesValue.fin_Revenue_3;
        } else if (this.salesValue.fin_Revenue_Name4 == this.graphData.fin_Revenue_Name4) {
            this.graphData.fin_Revenue_4 = this.salesValue.fin_Revenue_4;
        } else {
            this.graphData.fin_Revenue_4 = 0;
        }
    }

    plotFinancialSalesRevenueChart() {

        if (this.globals.finUser) {
            this.salesRevenue.refresh();
        }
    }

    saveFinancialSalesRevenue() {

        if (this.globals.finUser) {
            this.salesRevenue.saveFinSalesRevenueData();
        }
    }

    cancelFinancialSalesRevenue() {

        if (this.globals.finUser) {

            this.graphService = this.graph.getConfig();
            this.graphService.subscribe(data => {

                this.graphData = data.contents;
            });
            this.salesRevenue.load();
        }
    }

    prodCostInputQuarter(finCostInitialQuarter) {

        this.upstreamUnitProductionCost.changeQuarter(finCostInitialQuarter);
        this.switchQuarterYearValueUnitProdCost();
    }

    prodCostInputYear(initialRevYear) {

        this.upstreamUnitProductionCost.changeYear(initialRevYear);
        this.switchQuarterYearValueUnitProdCost();
    }

    switchQuarterYearValueUnitProdCost() {

        if (this.salesValue.fin_Cost_Name1 == this.graphData.fin_Cost_Name1) {
            this.graphData.fin_Cost_1 = this.salesValue.fin_Cost_1;
        } else if (this.salesValue.fin_Cost_Name2 == this.graphData.fin_Cost_Name1) {
            this.graphData.fin_Cost_1 = this.salesValue.fin_Cost_2;
        } else if (this.salesValue.fin_Cost_Name3 == this.graphData.fin_Cost_Name1) {
            this.graphData.fin_Cost_1 = this.salesValue.fin_Cost_3;
        } else if (this.salesValue.fin_Cost_Name4 == this.graphData.fin_Cost_Name1) {
            this.graphData.fin_Cost_1 = this.salesValue.fin_Cost_4;
        } else {
            this.graphData.fin_Cost_1 = 0;
        }

        if (this.salesValue.fin_Cost_Name1 == this.graphData.fin_Cost_Name2) {
            this.graphData.fin_Cost_2 = this.salesValue.fin_Cost_1;
        } else if (this.salesValue.fin_Cost_Name2 == this.graphData.fin_Cost_Name2) {
            this.graphData.fin_Cost_2 = this.salesValue.fin_Cost_2;
        } else if (this.salesValue.fin_Cost_Name3 == this.graphData.fin_Cost_Name2) {
            this.graphData.fin_Cost_2 = this.salesValue.fin_Cost_3;
        } else if (this.salesValue.fin_Cost_Name4 == this.graphData.fin_Cost_Name2) {
            this.graphData.fin_Cost_2 = this.salesValue.fin_Cost_4;
        } else {
            this.graphData.fin_Cost_2 = 0;
        }

        if (this.salesValue.fin_Cost_Name1 == this.graphData.fin_Cost_Name3) {
            this.graphData.fin_Cost_3 = this.salesValue.fin_Cost_1;
        } else if (this.salesValue.fin_Cost_Name2 == this.graphData.fin_Cost_Name3) {
            this.graphData.fin_Cost_3 = this.salesValue.fin_Cost_2;
        } else if (this.salesValue.fin_Cost_Name3 == this.graphData.fin_Cost_Name3) {
            this.graphData.fin_Cost_3 = this.salesValue.fin_Cost_3;
        } else if (this.salesValue.fin_Cost_Name4 == this.graphData.fin_Cost_Name3) {
            this.graphData.fin_Cost_3 = this.salesValue.fin_Cost_4;
        } else {
            this.graphData.fin_Cost_3 = 0;
        }

        if (this.salesValue.fin_Cost_Name1 == this.graphData.fin_Cost_Name4) {
            this.graphData.fin_Cost_4 = this.salesValue.fin_Cost_1;
        } else if (this.salesValue.fin_Cost_Name2 == this.graphData.fin_Cost_Name4) {
            this.graphData.fin_Cost_4 = this.salesValue.fin_Cost_2;
        } else if (this.salesValue.fin_Cost_Name3 == this.graphData.fin_Cost_Name4) {
            this.graphData.fin_Cost_4 = this.salesValue.fin_Cost_3;
        } else if (this.salesValue.fin_Cost_Name4 == this.graphData.fin_Cost_Name4) {
            this.graphData.fin_Cost_4 = this.salesValue.fin_Cost_4;
        } else {
            this.graphData.fin_Cost_4 = 0;
        }
    }

    plotFinancialUpstreamUnitProductionCostChart() {

        if (this.globals.finUser) {
            this.upstreamUnitProductionCost.refresh();
        }
    }

    saveFinancialUpstreamUnitProductionCost() {

        this.upstreamUnitProductionCost.saveUpstreamUnitProductionCostData();
    }

    cancelFinancialUpstreamUnitProductionCost() {

        if (this.globals.finUser) {

            this.graphService = this.graph.getConfig();
            this.graphService.subscribe(data => {

                this.graphData = data.contents;
            });
            this.upstreamUnitProductionCost.load();
        }
    }

    cashInputQuarter(finFreeCashFlowInitialQuarter) {

        this.freeCashFlow.changeQuarter(finFreeCashFlowInitialQuarter);
        this.switchQuarterYearValueFreeCashFlow();
    }

    cashInputYear(finFreeCashFlowInitialYear) {

        this.freeCashFlow.changeYear(finFreeCashFlowInitialYear);
        this.switchQuarterYearValueFreeCashFlow();
    }

    switchQuarterYearValueFreeCashFlow() {

        if (this.salesValue.fin_Cash_Name1 == this.graphData.fin_Cash_Name1) {
            this.graphData.fin_Cash_1 = this.salesValue.fin_Cash_1;
        } else if (this.salesValue.fin_Cash_Name2 == this.graphData.fin_Cash_Name1) {
            this.graphData.fin_Cash_1 = this.salesValue.fin_Cash_2;
        } else if (this.salesValue.fin_Cash_Name3 == this.graphData.fin_Cash_Name1) {
            this.graphData.fin_Cash_1 = this.salesValue.fin_Cash_3;
        } else if (this.salesValue.fin_Cash_Name4 == this.graphData.fin_Cash_Name1) {
            this.graphData.fin_Cash_1 = this.salesValue.fin_Cash_4;
        } else {
            this.graphData.fin_Cash_1 = 0;
        }

        if (this.salesValue.fin_Cash_Name1 == this.graphData.fin_Cash_Name2) {
            this.graphData.fin_Cash_2 = this.salesValue.fin_Cash_1;
        } else if (this.salesValue.fin_Cash_Name2 == this.graphData.fin_Cash_Name2) {
            this.graphData.fin_Cash_2 = this.salesValue.fin_Cash_2;
        } else if (this.salesValue.fin_Cash_Name3 == this.graphData.fin_Cash_Name2) {
            this.graphData.fin_Cash_2 = this.salesValue.fin_Cash_3;
        } else if (this.salesValue.fin_Cash_Name4 == this.graphData.fin_Cash_Name2) {
            this.graphData.fin_Cash_2 = this.salesValue.fin_Cash_4;
        } else {
            this.graphData.fin_Cash_2 = 0;
        }

        if (this.salesValue.fin_Cash_Name1 == this.graphData.fin_Cash_Name3) {
            this.graphData.fin_Cash_3 = this.salesValue.fin_Cash_1;
        } else if (this.salesValue.fin_Cash_Name2 == this.graphData.fin_Cash_Name3) {
            this.graphData.fin_Cash_3 = this.salesValue.fin_Cash_2;
        } else if (this.salesValue.fin_Cash_Name3 == this.graphData.fin_Cash_Name3) {
            this.graphData.fin_Cash_3 = this.salesValue.fin_Cash_3;
        } else if (this.salesValue.fin_Cash_Name4 == this.graphData.fin_Cash_Name3) {
            this.graphData.fin_Cash_3 = this.salesValue.fin_Cash_4;
        } else {
            this.graphData.fin_Cash_3 = 0;
        }

        if (this.salesValue.fin_Cash_Name1 == this.graphData.fin_Cash_Name4) {
            this.graphData.fin_Cash_4 = this.salesValue.fin_Cash_1;
        } else if (this.salesValue.fin_Cash_Name2 == this.graphData.fin_Cash_Name4) {
            this.graphData.fin_Cash_4 = this.salesValue.fin_Cash_2;
        } else if (this.salesValue.fin_Cash_Name3 == this.graphData.fin_Cash_Name4) {
            this.graphData.fin_Cash_4 = this.salesValue.fin_Cash_3;
        } else if (this.salesValue.fin_Cash_Name4 == this.graphData.fin_Cash_Name4) {
            this.graphData.fin_Cash_4 = this.salesValue.fin_Cash_4;
        } else {
            this.graphData.fin_Cash_4 = 0;
        }
    }

    plotFinancialFreeCashFlowChart() {

        if (this.globals.finUser) {
            this.freeCashFlow.refresh();
        }
    }

    saveFinancialFreeCashFlow() {

        this.freeCashFlow.saveFreeCashFlowData();
    }

    cancelFinancialFreeCashFlow() {

        if (this.globals.finUser) {

            this.graphService = this.graph.getConfig();
            this.graphService.subscribe(data => {

                this.graphData = data.contents;
            });
            this.freeCashFlow.load();
        }
    }

    gearingInputQuarter(finInitialQuarterGearing) {

        this.gearing.changeQuarter(finInitialQuarterGearing);
        this.switchQuarterYearValueGearing();
    }

    gearingInputYear(finInitialYearGearing) {

        this.gearing.changeYear(finInitialYearGearing);
        this.switchQuarterYearValueGearing();
    }

    switchQuarterYearValueGearing() {

        if (this.salesValue.fin_Gearing_Name1 == this.graphData.fin_Gearing_Name1) {
            this.graphData.fin_Gearing_1 = this.salesValue.fin_Gearing_1;
        } else if (this.salesValue.fin_Gearing_Name2 == this.graphData.fin_Gearing_Name1) {
            this.graphData.fin_Gearing_1 = this.salesValue.fin_Gearing_2;
        } else if (this.salesValue.fin_Gearing_Name3 == this.graphData.fin_Gearing_Name1) {
            this.graphData.fin_Gearing_1 = this.salesValue.fin_Gearing_3;
        } else if (this.salesValue.fin_Gearing_Name4 == this.graphData.fin_Gearing_Name1) {
            this.graphData.fin_Gearing_1 = this.salesValue.fin_Gearing_4;
        } else {
            this.graphData.fin_Gearing_1 = 0;
        }

        if (this.salesValue.fin_Gearing_Name1 == this.graphData.fin_Gearing_Name2) {
            this.graphData.fin_Gearing_2 = this.salesValue.fin_Gearing_1;
        } else if (this.salesValue.fin_Gearing_Name2 == this.graphData.fin_Gearing_Name2) {
            this.graphData.fin_Gearing_2 = this.salesValue.fin_Gearing_2;
        } else if (this.salesValue.fin_Gearing_Name3 == this.graphData.fin_Gearing_Name2) {
            this.graphData.fin_Gearing_2 = this.salesValue.fin_Gearing_3;
        } else if (this.salesValue.fin_Gearing_Name4 == this.graphData.fin_Gearing_Name2) {
            this.graphData.fin_Gearing_2 = this.salesValue.fin_Gearing_4;
        } else {
            this.graphData.fin_Gearing_2 = 0;
        }

        if (this.salesValue.fin_Gearing_Name1 == this.graphData.fin_Gearing_Name3) {
            this.graphData.fin_Gearing_3 = this.salesValue.fin_Gearing_1;
        } else if (this.salesValue.fin_Gearing_Name2 == this.graphData.fin_Gearing_Name3) {
            this.graphData.fin_Gearing_3 = this.salesValue.fin_Gearing_2;
        } else if (this.salesValue.fin_Gearing_Name3 == this.graphData.fin_Gearing_Name3) {
            this.graphData.fin_Gearing_3 = this.salesValue.fin_Gearing_3;
        } else if (this.salesValue.fin_Gearing_Name4 == this.graphData.fin_Gearing_Name3) {
            this.graphData.fin_Gearing_3 = this.salesValue.fin_Gearing_4;
        } else {
            this.graphData.fin_Gearing_3 = 0;
        }

        if (this.salesValue.fin_Gearing_Name1 == this.graphData.fin_Gearing_Name4) {
            this.graphData.fin_Gearing_4 = this.salesValue.fin_Gearing_1;
        } else if (this.salesValue.fin_Gearing_Name2 == this.graphData.fin_Gearing_Name4) {
            this.graphData.fin_Gearing_4 = this.salesValue.fin_Gearing_2;
        } else if (this.salesValue.fin_Gearing_Name3 == this.graphData.fin_Gearing_Name4) {
            this.graphData.fin_Gearing_4 = this.salesValue.fin_Gearing_3;
        } else if (this.salesValue.fin_Gearing_Name4 == this.graphData.fin_Gearing_Name4) {
            this.graphData.fin_Gearing_4 = this.salesValue.fin_Gearing_4;
        } else {
            this.graphData.fin_Gearing_4 = 0;
        }
    }

    plotFinancialGearingGraph() {

        if (this.globals.finUser) {
            this.gearing.refresh();
        }
    }

    saveFinancialGearing() {

        this.gearing.saveFGearingData();
    }

    cancelFinancialGearing() {

        if (this.globals.finUser) {

            this.graphService = this.graph.getConfig();
            this.graphService.subscribe(data => {

                this.graphData = data.contents;
            });
            this.gearing.load();
        }
    }

    saveEhs() {
        this.globals.hasLoaded = false;

        let ehsConfigModel: EhsConfigModel = new EhsConfigModel();
        ehsConfigModel.ehs_CurrentYear = this.graphData.ehs_CurrentYear;
        ehsConfigModel.ehs_Injury_CurrentYearValue_Offshore = this.graphData.ehs_Injury_CurrentYearValue_Offshore;
        ehsConfigModel.ehs_Injury_LastYearValue_Offshore = this.graphData.ehs_Injury_LastYearValue_Offshore;
        ehsConfigModel.ehs_InjuryDays_LastDate_Offshore = this.graphData.ehs_InjuryDays_LastDate_Offshore;
        ehsConfigModel.ehs_InjuryDays_BestPerformanceOffshore = this.graphData.ehs_InjuryDays_BestPerformanceOffshore;
        ehsConfigModel.ehs_Process_CurrentYearValue_Offshore = this.graphData.ehs_Process_CurrentYearValue_Offshore;
        ehsConfigModel.ehs_Process_LastYearValue_Offshore = this.graphData.ehs_Process_LastYearValue_Offshore;

        this.graphService = this.graph.saveEhsConfig(ehsConfigModel);
        this.graphService.subscribe(data => {
            console.log('Saved EHS Graphs:');
            this.globals.hasLoaded = true;
            setTimeout(() => {
                this.messageService.sendSuccessMessage("Saved EHS Configuration Successfully");
            }, 200)
            this.router.navigate(['/']);
        }, err => {
            console.log(err);
            this.globals.hasLoaded = true;
            let msg = "Error saving EHS graph details";
            if (err.message != undefined)
                msg += ': ' + err.message;
            this.messageService.sendErrorMessage(msg);
        });
    }

    cancelEhs() {
        this.graphData = this.saveGraphData;
        this.router.navigate(['/']);
    }

    public onDateChange(value: Date): void {
        this.graphData.ehs_InjuryDays_LastDate_Offshore = value;
    }

}